import { useAuth, type VaultTenantInput } from '../lib/auth-context';
import { useNavigate } from 'react-router-dom';
import { QuickConnect } from '../components/QuickConnect';

export function Login() {
  const { connect, importVault, connectSaved, hasSavedVault, clearVault } = useAuth();
  const navigate = useNavigate();

  const handleConnect = async (url: string, apiKey: string, _remember: boolean) => {
    await connect(url, apiKey);
    navigate('/overview');
  };

  const handleImportVault = async (entries: VaultTenantInput[]) => {
    const result = await importVault(entries);
    if (result.ok > 0) {
      navigate('/overview');
    }
    return result;
  };

  const handleOpenSaved = async () => {
    await connectSaved();
    navigate('/overview');
  };

  return (
    <QuickConnect
      onConnect={handleConnect}
      onImportVault={handleImportVault}
      onOpenSaved={hasSavedVault ? handleOpenSaved : undefined}
      onClearVault={hasSavedVault ? clearVault : undefined}
      hasSavedVault={hasSavedVault}
    />
  );
}
